import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios'
import { fetchAuthSession, signOut as amplifySignOut } from 'aws-amplify/auth'
import { apiConfig, isLocalhostSignIn, redirectToSignIn } from '@/config/aws'

// Axiosインスタンス作成
const api = axios.create({
  baseURL: apiConfig.baseUrl,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
})

// リクエストインターセプター（認証トークン追加）
api.interceptors.request.use(
  async (config: InternalAxiosRequestConfig) => {
    try {
      const session = await fetchAuthSession()
      const token = session.tokens?.idToken?.toString()

      if (token && config.headers) {
        config.headers.Authorization = `Bearer ${token}`
      }
    } catch (error) {
      console.error('Failed to get auth token:', error)
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 認証エラー時の Cognito 再サインインを 1 回だけ走らせるためのフラグ
// （/login というルートは存在しないので window.location リダイレクトはループの原因になる）
let reauthInFlight = false

// レスポンスインターセプター（エラーハンドリング）
api.interceptors.response.use(
  (response) => response,
  async (error: AxiosError) => {
    if (error.response?.status === 401 && !reauthInFlight) {
      reauthInFlight = true
      try {
        // localhost は独自セッションなので stale token をクリアしてから再サインイン。
        // 本番は portal と Cookie を共有しており、ここで signOut すると portal や
        // 他サブアプリのセッションまで破棄してしまうため呼ばない（portal 側で再認証）。
        if (isLocalhostSignIn) {
          await amplifySignOut()
        }
        await redirectToSignIn()
      } catch (e) {
        console.error('Re-auth failed:', e)
        reauthInFlight = false
      }
    }

    return Promise.reject(error)
  }
)

export default api
